<template>
    <div>
        <simpleHeaderBar name="问题反馈"></simpleHeaderBar>
        <div style="margin: 100px;" v-if="loading">
            <LoadingBar height="120px"></LoadingBar>
        </div>
        <div v-else>
            <div class="survey">
                <div class="survey-reply-header">
                    我的问题 — 查看详情
                </div>
                <div class="survey-input" v-if="result.FeedBack != null">
                    <div class="reply-box">
                        <ul>
                            <li>
                                <label>
                                    反馈主题：
                                </label>
                                <div class="reply-info">
                                    {{result.FeedBack.feedbackTheme}}
                                </div>
                            </li>
                            <li>
                                <label>
                                    反馈内容：
                                </label>
                                <div class="reply-info" v-html="result.FeedBack.feedbackContent.replace(/＼n/g,'<br/>').replace(/\n/g,'<br/>')">
                                </div>
                            </li>
                            <li v-if="result.FeedBack.userClinicName != null">
                                <label>
                                    医疗机构：
                                </label>
                                <div class="reply-info">
                                    {{result.FeedBack.userClinicName}}
                                </div>
                            </li>
                            <li v-if="result.FeedBackImages != null && result.FeedBackImages.length > 0">
                                <label>
                                    图片：
                                </label>
                                <div class="reply-info">
                                    <div class="img-list">
                                        <img v-for="item in result.FeedBackImages" :src="item.imageServerPath + item.imageRelativePath" alt="">
                                    </div>
                                </div>
                            </li>
                            <li>
                                <label>
                                    联系人：
                                </label>
                                <div class="reply-info">{{result.FeedBack.contactName}}</div>
                            </li>
                            <li>
                                <label>
                                    联系电话：
                                </label>
                                <div class="reply-info">
                                    {{result.FeedBack.contactPhone}}
                                </div>
                            </li>
                            <li v-if="result.FeedBack.feedbackResult">
                                <label>
                                    回复内容：
                                </label>
                                <div class="reply-info">
                                    {{result.FeedBack.feedbackResult}}
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="reply-box reply-box-a">
                        <ul>
                            <li>
                                <label>
                                    是否解决：
                                </label>
                                <div class="reply-info">
                                    <RadioGroup v-model="reply.solveState"  v-if="result.FeedBack.evaluateStatus == 0 || result.FeedBack.evaluateStatus == null">
                                        <Radio class="radio" label="1">已解决</Radio>
                                        <Radio class="radio" label="0">未解决</Radio>
                                    </RadioGroup>
                                    <RadioGroup class="radio-disabled" v-model="result.FeedBack.solveState" v-else> <!--result.FeedBack.solveState-->
                                        <Radio class="radio" label="1" disabled>已解决</Radio>
                                        <Radio class="radio" label="0" disabled>未解决</Radio>
                                    </RadioGroup>
                                </div>
                            </li>
                            <li>
                                <label>
                                    满意度评价：
                                </label>
                                <div class="reply-info">
                                    <div class="star">
                                        <Rate v-if="result.FeedBack.evaluateStatus == 0 || result.FeedBack.evaluateStatus == null" v-model="reply.evaluateStars"></Rate>
                                        <Rate v-else disabled v-model="result.FeedBack.evaluateStars"></Rate>
                                    </div>
                                </div>
                            </li>
                            <li v-if="result.FeedBack.evaluateStatus == 0 || result.FeedBack.evaluateStatus == null">
                                <label>
                                    评价内容：
                                </label>
                                <div class="reply-info">
                                    <Input  class="textarea" v-model="reply.evaluateContent" type="textarea" :autosize="{minRows: 5,maxRows: 10}"
                                           placeholder="请输入评价内容(200字以内)" :maxlength="maxLength200"></Input>
                                </div>
                            </li>
                            <li v-else-if="result.FeedBack.evaluateStatus == 1 && result.FeedBack.evaluateContent != null && result.FeedBack.evaluateContent.length > 0">
                                <label>
                                    评价内容：
                                </label>
                                <div class="reply-info">
                                    <p v-html="result.FeedBack.evaluateContent.replace(/＼n/g,'<br/>').replace(/\n/g,'<br/>')">
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="btn" v-if="result.FeedBack.evaluateStatus == 0 || result.FeedBack.evaluateStatus == null">
                        <Button type="primary" class="btn-submit" :loading="submitLoading"
                                @click="handleSubmit()">
                            <span v-if="!submitLoading">提交</span>
                            <span v-else>Loading...</span>
                        </Button>
                    </div>
                </div>
                <div class="survey-input"  v-else>
                    <div class="no-result">
                        <p style="text-align: center; font-size: 14px; margin: 100px;">暂无数据</p>
                    </div>
                </div>
            </div>
        </div>
        <simpleFooterBar></simpleFooterBar>
    </div>
</template>
<script>
    import simpleHeaderBar from './../Common/simpleHeaderBar';
    import simpleFooterBar from './../Common/simpleFooterBar';
    import LoadingBar from './../Utils/loadingBar';
    import url from './../../../config/url';
    import axios from 'axios';
    export default {
        components: {
            simpleHeaderBar: simpleHeaderBar,
            simpleFooterBar: simpleFooterBar,
            LoadingBar: LoadingBar,
        },
        data() {
            return {
                submitLoading: false,
                loading:true,
                maxLength200: 200,
                feedbackSource: 0,
                result:{},
                feedbackId: this.$route.query.feedbackId,
                reply:{
                    solveState: 1,
                    evaluateStars:1,
                    evaluateContent: ""
                }
            }
        },
        created: function () {
            this.getFeedbackInfo();
        },
        mounted: function () {

        },
        methods: {
            getFeedbackInfo(){
                var _this = this;
                var params = {
                    feedbackId: _this.feedbackId,
                    feedbackSource: _this.feedbackSource,
                    userId: url.userId
                };
                axios.get(url.getFeedbackInfo,{
                    params: params
                }).then(function (response) {
                    var res = response.data;
                    _this.loading = false;
                    if(res.status == "SUCCESS" && res.result != null){
                        _this.result = res.result;
                        _this.feedbackSource = res.result.FeedBack.feedbackSource;
                    }
                }).catch(function () {
                    _this.$Message.error('数据获取失败,请稍后再试!');
                });
            },
            handleSubmit(){
                this.submitLoading = true;
                var _this = this;
                var params = {
                    feedbackId: _this.feedbackId,
                    solveState: _this.reply.solveState,
                    evaluateStars: _this.reply.evaluateStars,
                    evaluateContent: _this.reply.evaluateContent.trim(),
                    feedbackSource: _this.feedbackSource
                };
                axios.get(url.saveFeedbackEvaluate,{
                    params: params
                }).then(function (response) {
                    var res = response.data;
                    _this.submitLoading = false;
                    if(res.status == "SUCCESS"){
                        _this.$Message.success('提交成功');
                        _this.getFeedbackInfo();
                    }else {
                        _this.$Message.error(res.errorMsg);
                    }
                }).catch(function () {
                    _this.$Message.error('数据获取失败,请稍后再试!');
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../../static/scss/page/survey";
</style>
<style lang="scss">
    .reply-box-a{
        .ivu-radio-wrapper{
            font-size: 14px !important;
        }
        textarea{
            border-radius: 0 !important;
        }
        .radio-disabled .ivu-radio-inner:after{
            background-color: #bbb !important;
        }
        .radio-disabled .ivu-radio-checked .ivu-radio-inner {
            border-color: #bbb !important;
        }
        .ivu-radio-inner:after {
            background-color: #3d8ff5;
        }
        .ivu-radio-checked .ivu-radio-inner{
            border-color: #d7dde4;
        }
        .ivu-radio-checked:hover .ivu-radio-inner {
            border-color: #d7dde4;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Survey/reply.vue